import { render } from "./Dept.vue?vue&type=template&id=f9fee61e&scoped=true"
import script from "./Dept.vue?vue&type=script&lang=js"
export * from "./Dept.vue?vue&type=script&lang=js"

import "./Dept.vue?vue&type=style&index=0&id=f9fee61e&lang=less&scoped=true"
import "./Dept.vue?vue&type=style&index=1&id=f9fee61e&lang=less"
import "./Dept.vue?vue&type=style&index=2&id=f9fee61e&scoped=true&lang=css"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fee61e"]])

export default __exports__